
export interface DtoCurrentUser {
    customerID?: number | null;
    email?: string | null;
    professionalEmail?: string | null;
    firstAndLastName?: string | null;
    isLoggedIn: boolean;
    isApproved: boolean;
    isMember: boolean;
    hasSomeAdminAccess: boolean;
    defaultBillablePartyID: number | null;
    taxable: boolean;
}

export function createDtoCurrentUser(userContext?: DtoCurrentUser | any) {
    const result = <DtoCurrentUser> {
        customerID: null,
        email: null,
        professionalEmail: null,
        firstAndLastName: null,
        isLoggedIn: false,
        isApproved: false,
        isMember: false,
        hasSomeAdminAccess: false,
        defaultBillablePartyID: null,
        taxable: true
    };

    if (userContext) {
        Object.assign(result, userContext);
    }
    return result;
}